import * as styles from "./articleCard.module.scss"
import React from "react";
import { navigate } from "gatsby";
import { ReactSVG } from "react-svg";
import addCross from "../../../../static/vectors/addCross.svg"
import moment from "moment";

type ArticleCardProps = {
    image: string
    title: string
    type?: string
    date?: string
    infos: string
    bgColor: string
    textColor: string
    iconColor: string
    circleColor: string
    link: string
    fullscreedMode?: boolean
    double?: boolean
    padding?: string
    style?: React.CSSProperties
}

const ArticleCard: React.FC<ArticleCardProps> = (props: ArticleCardProps) => {
    const handleClick = () => {
        navigate(props.link)
    }

    return (
        <a 
            href={props.link}
            className={props.double ? styles.newsDouble : styles.news} 
            style={{
                ...(props.padding ? {padding: props.padding} : {}),
                ...(props.style || {}),
                textDecoration: 'none'
            }}
        >
            <div
                className={props.double ? styles.newsImageDouble : styles.newsImage}
                style={
                    props.image
                        ? {
                            backgroundImage: `url(${props.image})`,
                            backgroundSize: "cover",
                            backgroundPosition: "center",
                            borderRadius: !props.fullscreedMode
                                ? props.double
                                    ? "0 28px 28px 0"
                                    : "28px 28px 0 0"
                                : undefined,
                        }
                        : {
                            backgroundColor: "#FFFF74",
                            borderRadius: !props.fullscreedMode
                                ? props.double
                                    ? "0 28px 28px 0"
                                    : "28px 28px 0 0"
                                : undefined,
                        }
                }
            />

            <div className={props.double ? styles.newsInfoContainerDouble : styles.newsInfoContainer}
                style={{
                    backgroundColor: props.bgColor,
                    borderRadius: !props.fullscreedMode
                        ? props.double
                            ? "28px 0 0 28px "
                            : "0 0 28px 28px"
                        : undefined,
                }}>
                <div>
                    <div className={styles.newsTitleContainer}>
                            <h3 className={props.double ? styles.newsTitleDouble : styles.newsTitle} style={{ color: props.textColor }}>
                                {props.title}
                            </h3>
                        <div>
                            <p className={styles.newsDate} style={{ color: props.textColor }}>
                                {props.type}
                            </p>
                            <p className={styles.newsDate} style={{ color: props.textColor }}>
                                {props.date ? `${moment(props.date).format("DD.MM.YYYY")}` : null}
                            </p>
                        </div>
                    </div>
                    <p className={props.double ? styles.newsInfosDouble : styles.newsInfos} style={{ color: props.textColor }}>
                        {props.infos}
                    </p>
                </div>
                <div className={styles.circle} style={{ backgroundColor: props.circleColor }}>
                    <ReactSVG src={addCross} beforeInjection={(svg) => {
                        const paths = svg.querySelectorAll('path')
                        paths.forEach(path => path.setAttribute('stroke', props.iconColor))
                    }} />
                </div>
            </div>
        </a>
    )
}

export default ArticleCard